import { useAppDispatch, useAppSelector } from "app/hooks"
import { useCallback, useEffect, useRef } from "react"
import { getSuggestedMeals, resetSuggestedMeals } from "../mealSlice"
import { useFailed, useSuccess } from "features/notification/hooks"

export const useSuggestedMeals = (isInDiary?: boolean) => {

  const suggestedMeals = useAppSelector((state) => state.meal.suggestedMeals)
  const getSuggestedMealsLoading = useAppSelector(
    (state) => state.meal.getSuggestedMealsLoading,
  )
  const getSuggestedMealsFailed = useAppSelector(
    (state) => state.meal.getSuggestedMealsFailed,
  )

  const isNoSuggestedMeals = useAppSelector(
    (state) => state.meal.isNoSuggestedMeals,
  )

  const hasMore = useAppSelector((state) => state.meal.hasMoreSuggestedMeals)

  const page = useAppSelector((state) => state.meal.suggestedMealsPage)
  const dispatch = useAppDispatch()

  const isFirstLoad = useRef(true)

  const loadMore = async () => {
    const currentPage = isFirstLoad.current ? 0 : page

    if (getSuggestedMealsLoading && currentPage !== 0) {
      return Promise.resolve()
    }

    isFirstLoad.current = false
    return (await dispatch(getSuggestedMeals({ page: currentPage + 1 }))) as any
  }

  useFailed(getSuggestedMealsFailed)

  useEffect(() => {
    if (isInDiary) {
      loadMore()
    }

    return () => {
      dispatch(resetSuggestedMeals())
    }
  }, [])

  const reloadSuggestedMealsTimeout = useRef<any>(null)

  const handleReloadSuggestedMeals = useCallback(
    (withDebounce = false) => {
      if (!isInDiary) return

      if (reloadSuggestedMealsTimeout.current) {
        clearTimeout(reloadSuggestedMealsTimeout.current)
      }

      if (withDebounce) {
        const debounceTime = 1000
        reloadSuggestedMealsTimeout.current = setTimeout(() => {
          isFirstLoad.current = true
          loadMore()
        }, debounceTime)
      } else {
        isFirstLoad.current = true
        loadMore()
      }
    },
    [isInDiary, loadMore],
  )

  const logMealSuccess = useAppSelector((state) => state.meal.logMealSuccess)
  useSuccess(logMealSuccess, { message: "" }, () => {
    handleReloadSuggestedMeals(true)
  })

  const deleteMealSuccess = useAppSelector(
    (state) => state.home.deleteMealSuccess,
  )
  useSuccess(deleteMealSuccess, { message: "" }, () => {
    handleReloadSuggestedMeals(false)
  })

  return {
    suggestedMeals,
    getSuggestedMealsLoading,
    isNoSuggestedMeals,
    loadMore,
    hasMore,
  }
}
